var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClothingBody(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    style: {
      height: 512,
      width: 512
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-bg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h512v512H0z",
    fill: "#417505",
    fillOpacity: 0,
    transform: "translate(512, 512) scale(-1, -1) rotate(-180, 256, 256) skewX(0) skewY(0)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h512v512H0z",
    fill: "#417505",
    fillOpacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    className: "",
    transform: "translate(0,0)",
    style: {}
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M255.973 22.965c-43.313 0-95.117 14.71-126.66 30.12-33.538 13.63-60.84 30.408-80.33 60.542-26.22 40.536-38.948 103.153-30.278 202.797 24.886 8.635 47.288 6.054 70.272-1.73-7.203-32.898-6.04-65.776 2.072-92.645 8.872-29.395 26.72-53.085 52.886-57.17l11.56-1.804.305 11.697c.226 8.523.38 17.397.485 26.434l.113 26.338c-.155 36.707-1.593 76.298-5.328 116.182 23.522 7.64 61.78 12.326 99.99 12.597l19.18-.244c35.59-1.145 69.858-6.043 90.4-12.78-4.562-61.128-4.866-122.812-6.34-172.464l-.407-13.7 13.267 3.44c26.03 6.746 44.022 30.776 53.246 60.528 8.425 27.166 9.814 59.957 2.668 92.833 17.938 5.68 35.678 7.15 53.602 4.926l18.355-2.453c4.31-78.49-5.98-156.066-26.157-193.04L450.48 96.767c-19.39-22.354-44.318-35.044-73.71-46.207-28.146-14.427-76.6-27.595-120.797-27.595zm0 12.724c27.095 0 55.783 8.103 80.42 18.845-13.03 11.505-29.087 19.462-46.176 24.008l-32.764 72.228-28.53-70.442c-19.852-3.88-38.642-12.34-53.34-25.76 25.763-11.032 54.585-18.88 80.39-18.88zm2.416 119.08l14.655 22.226-14.59 21.084-14.725-21.084 14.66-22.226zm0 49.603l14.655 22.23-14.59 21.083-14.725-21.084 14.66-22.23zm0 48.957l14.655 22.227-14.59 21.086-14.725-21.086 14.66-22.227zm0 49.553l14.655 22.228-14.59 21.085-14.725-21.084 14.66-22.227zm104.645 57.226c-27.583 8.572-66.045 12.127-105.467 12.314-39.638.188-79.132-3.107-108.078-12.07-.854 7.45-1.793 14.893-2.828 22.312 24.902 8.897 68.203 14.22 110.56 14.016 42.322-.205 84.93-6.02 108.116-14.32-.848-7.374-1.613-14.796-2.303-22.253zm5.71 37.913c-28.3 9.63-68.984 13.61-110.698 13.81-12.246.06-24.475-.22-36.402-.89l-17.637-1.314c-22.358-2.09-43.007-5.768-59.787-11.507-3.742 22.658-8.426 44.944-14.243 66.354 8.833 4.422 18.403 8.212 28.52 11.404l16.564 4.575c66.132 15.875 149.713 8.995 206.963-14.658-5.656-21.24-9.96-44.108-13.28-67.774z",
    fill: "#a36528",
    fillOpacity: 1,
    clipPath: "url(#icon-bg)",
    transform: "translate(512, 512) scale(-1, -1) rotate(-180, 256, 256) skewX(0) skewY(0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClothingBody);
export default __webpack_public_path__ + "static/media/clothing-body.bcb70c35107c847f8b029ea523d47b94.svg";
export { ForwardRef as ReactComponent };